/* TrustSignalCard.tsx generated by @compiled/babel-plugin v0.26.0 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _4 = "._19pk1eps{margin-top:var(--ds-space-100)}";
const _3 = "._syaz1jij{color:var(--ds-text-subtlest)}";
import { BodyLarge, H2 } from '@atlassian/mpac-primitives';
import React from 'react';
const _2 = "._2rko1yyw{border-radius:1pc 0}";
const _ = "._1yt4hiv4{padding:var(--ds-space-400)}";
const Card = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1yt4hiv4 _2rko1yyw", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  Card.displayName = 'Card';
}
const Label = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = BodyLarge,
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_3, _4]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_syaz1jij _19pk1eps", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  Label.displayName = 'Label';
}
export const TrustSignalCard = _ref3 => {
  let {
    stats,
    label,
    cardStyles,
    statsStyles
  } = _ref3;
  return /*#__PURE__*/React.createElement(Card, {
    style: cardStyles
  }, /*#__PURE__*/React.createElement(H2, {
    style: statsStyles
  }, stats), /*#__PURE__*/React.createElement(Label, null, label));
};